import * as stylex from "@stylexjs/stylex";
import { motion } from "framer-motion";
import React from "react";
import { typography } from "../../../materials/typography.stylex";
import { springConfigs } from "../motion";
import { lineChartDefaultStyles } from "../shared/styles";
const HoverText = React.memo(({ x, y, textFlippedV, textAnchor, title, xLabel, yLabel })=><motion.g initial={{
        translateX: x,
        y,
        opacity: 0,
        scale: 0.9
    }} animate={{
        translateX: x,
        y,
        opacity: 1,
        scale: 1
    }} exit={{
        translateX: x,
        y,
        opacity: 0,
        scale: 0.9
    }} transition={springConfigs.gentle}>
      <text textAnchor={textAnchor}>
        <tspan {...stylex.props(typography.meta, lineChartDefaultStyles.title)} x={0} dx={textAnchor === "end" ? "-16px" : "16px"} dy={textFlippedV ? "1.6em" : "0.3em"}>
          {title}
        </tspan>
        <tspan {...stylex.props(typography.meta, lineChartDefaultStyles.label)} x={0} dx={textAnchor === "end" ? "-16px" : "16px"} dy={"1.2em"}>
          {xLabel}
        </tspan>
        <tspan {...stylex.props(typography.meta, lineChartDefaultStyles.label)} x={0} dx={textAnchor === "end" ? "-16px" : "16px"} dy={"1.2em"}>
          {yLabel}
        </tspan>
      </text>
    </motion.g>);
export default HoverText;
